import React from "react";

const TextAreaField = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  rows = 4,
  labelPosition = "left", // "top" | "left"
}) => {
  const isTop = labelPosition === "top";

  return (
    <div
      className={`mb-4 w-full ${isTop
          ? "flex flex-col gap-1"
          : "flex flex-col sm:flex-row items-start sm:items-center gap-2"
        }`}
    >
      {label && (
        <label
          htmlFor={id}
          className={`text-base font-medium text-black ${isTop ? "" : "whitespace-nowrap"
            }`}
          style={!isTop ? { flexShrink: 0 } : undefined}
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <textarea
        id={id}
        name={id}
        disabled={disabled}
        value={value}
        onChange={onChange}
        rows={rows}
        className={`w-full px-3 py-2 bg-slate-50 border-0 border-b-2 border-b-gray-300 rounded-md
          focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none text-black
          ${!isTop ? "sm:max-w-[60%] flex-1" : ""}
            ${disabled ? "!text-black !opacity-100 font-small" : "font-medium"}
        `}
      />
    </div>
  );
};

export default TextAreaField;
